import React from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "components/ui/dialog";
import { Checkbox } from "components/ui/checkbox";
import { Button as AppButton } from "components/ui/button";
import { SiteSystemType } from "api/ApiClient";

type Props = {
  open: boolean;
  systemType: SiteSystemType.Brivo | SiteSystemType.Openpath;
  busy?: boolean;
  onCancel: () => void;
  onConfirm: () => void;
};

export default function CloudManagedWarningDialog({
  open,
  systemType,
  busy,
  onCancel,
  onConfirm,
}: Props) {
  const [understood, setUnderstood] = React.useState(false);

  React.useEffect(() => {
    if (!open) {
      setUnderstood(false);
    }
  }, [open]);

  const handleOpenChange = (nextOpen: boolean) => {
    if (!nextOpen && !busy) {
      onCancel();
    }
  };

  return (
    <Dialog open={open} onOpenChange={handleOpenChange}>
      <DialogContent showCloseButton={false} className="sm:max-w-lg">
        <DialogHeader>
          <DialogTitle>Cloud-Managed Group</DialogTitle>
          <DialogDescription>
            This group is managed by{" "}
            {systemType === SiteSystemType.Openpath ? "OpenPath" : "Brivo"}.
            The cloud system is the source of truth for membership. Changes made
            here may be overwritten during the next sync.
          </DialogDescription>
        </DialogHeader>
        <div className="flex items-center gap-2 pt-2">
          <Checkbox
            id="cloud-managed-group-understood"
            checked={understood}
            onCheckedChange={(checked) => setUnderstood(checked === true)}
          />
          <label
            className="cursor-pointer text-sm font-medium"
            htmlFor="cloud-managed-group-understood"
          >
            I understand
          </label>
        </div>
        <DialogFooter>
          <AppButton onClick={onCancel} disabled={busy} type="button" variant="outline">
            Cancel
          </AppButton>
          <AppButton
            variant="warning"
            disabled={!understood || !!busy}
            onClick={onConfirm}
            type="button"
          >
            Continue
          </AppButton>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
